<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <h1 class="text-left" style="margin-top:20px;">Favorites</h1>
      <p class="text-left" v-if="store.state.loadedFavorites && store.state.favorites.length < 1">You don't have anything in your favorites yet</p>
      <div class="favorite-item" v-for="listing in store.state.favorites" :key="listing.id">
        <div class="row">
          <div class="col-sm-12 text-right">
            <button @click="unfavorite(listing)" class="btn btn-warning white btn-orange">Unfavorite</button>
          </div>
        </div>
        <div class="row">
          <div
            style="margin-top:20px;text-align:left;"
            v-for="field in listing.fields"
            class="col-sm-6"
            :key="field.id"
          >
            <h4>{{field.name}}</h4>
            <a
              :href="'mailto:' + utils.findFieldValue(listing,field.name)"
              v-if="field.type == 'Email'"
            >{{utils.findFieldValue(listing,field.name)}}</a>
            <a
              target="_blank"
              :href="utils.findFieldValue(listing,field.name)"
              v-else-if="field.type == 'Website'"
            >{{utils.findFieldValue(listing,field.name)}}</a>
            <p v-else>{{utils.findFieldValue(listing,field.name)}}</p>
          </div>

          <div
            style="margin-top:20px;text-align:left;"
            class="col-sm-6"
          >
            <h4>City</h4>
            <p>{{listing.city}}</p>
          </div>

          <div
            style="margin-top:20px;text-align:left;"
            class="col-sm-6"
          >
            <h4>State</h4>
            <p>{{listing.state}}</p>
          </div>


        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "../nav/NavigationBar";
import DashboardFooter from "../nav/Footer";
import Utils from "@/Utils/Utils";
import Navigator from "@/router/navigator";
import FavoritesStore from "./FavoritesStore";
import AccountSessionUtils from "./AccountSessionUtils";
import moment from 'moment'

export default {
  name: "Favorites",
  components: {
    NavigationBar,
    DashboardFooter
  },
  data() {
    return {
      nav: Navigator,
      store: FavoritesStore,
      accountUtils: AccountSessionUtils,
      utils: Utils
    };
  },
  mounted() {
    this.store.reset()
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
        if (userId == "0") {
          this.nav.goRegister(this);
          return;
        }
        this.getFavorites();
      },
      err => {
        this.$toasted.show(err, { type: "error", duration: 2500 });
      }
    );
  },
  computed: {},
  methods: {
    getFavorites() {
      this.store.getFavorites(
        data => {
        },
        err => {
        }, () => {
        this.nav.goMaintenance(this)
        }
      );
    },
    unfavorite(listing) {
      if(this.store.state.currentUserId == 0){
        this.$toasted.show('Login or create an account to favorite a listing', { type: "error", duration: 2500 });
      }else{
        this.store.unfavorite(
        listing.id,
        data => {
          this.getFavorites();
        },
        err => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        }, () => {
          this.nav.goMaintenance(this)
        })
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.favorite-item{
  background: white;
  border-radius: 10px;
  padding:20px;
  margin-top:20px;
  margin-bottom:20px;
}
.white{
  color:white;
}

a {
  color:#FF6F5E; 
}
</style>



// WEBPACK FOOTER //
// src/components/account/Favorites.vue